module.exports = __webpack_public_path__ + "static/media/ico-castbox.4fb65b76.svg";